import { getEnvConfig } from 'src/helpers/config';

export const initScripts = () => {
  injectGTMScript();
  injectClarityScript();
};

const injectGTMScript = () => {
  const { gtm } = getEnvConfig();

  if (!gtm) {
    return;
  }

  const script = document.createElement('script');
  const inlineCode = document.createTextNode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtm}');`);

  script.appendChild(inlineCode);
  script.async = false;
  document.body.appendChild(script);
};

const injectClarityScript = () => {
  const { clarity } = getEnvConfig();

  if (!clarity) {
    return;
  }

  const script = document.createElement('script');
  const inlineCode = document.createTextNode(`(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${clarity}");`);

  script.appendChild(inlineCode);
  script.async = false;
  document.body.appendChild(script);
};
